'use strict'

const { bytesToBase64 } = require('./image-column')

function byteMap (value) {

  if (!value || typeof value !== 'object' || Array.isArray(value)) return null
  if (value.type === 'Buffer' || value.omitted) return null

  const keys = Object.keys(value)

  if (!keys.length) return null

  const bytes = new Array(keys.length)

  for (let i = 0; i < keys.length; i += 1) {

    if (keys[i] !== String(i)) return null

    const byte = value[keys[i]]

    if (!Number.isInteger(byte) || byte < 0 || byte > 255) return null

    bytes[i] = byte
  }

  return bytes
}

function historyBytes (value) {

  if (!value) return null
  if (typeof value === 'string') return null
  if (value.type === 'Buffer' && Array.isArray(value.data)) return value.data.slice()
  if (Array.isArray(value)) {

    for (let i = 0; i < value.length; i += 1) {

      const byte = value[i]

      if (!Number.isInteger(byte) || byte < 0 || byte > 255) return null
    }

    return value.slice()
  }

  return byteMap(value)
}

function sniffedImageType (bytes) {

  if (!bytes || bytes.length < 4) return null

  if (bytes[0] === 137 && bytes[1] === 80 && bytes[2] === 78 && bytes[3] === 71) return 'image/png'
  if (bytes[0] === 255 && bytes[1] === 216 && bytes[2] === 255) return 'image/jpeg'
  if (bytes[0] === 71 && bytes[1] === 73 && bytes[2] === 70) return 'image/gif'
  if (bytes.length >= 12 && bytes[0] === 82 && bytes[1] === 73 && bytes[2] === 70 && bytes[3] === 70 && bytes[8] === 87 && bytes[9] === 69 && bytes[10] === 66 && bytes[11] === 80) {

    return 'image/webp'
  }

  return null
}

function historyImagePreview (side, field) {

  if (!side || !field || typeof field !== 'string') return null
  if (field.endsWith('_type') || field.endsWith('_filename')) return null

  const value = side[field]

  if (value == null || value === '') return null

  const declared = typeof side[`${field}_type`] === 'string' ? side[`${field}_type`] : ''

  if (typeof value === 'object' && value.omitted === 'binary') {

    if (declared.startsWith('image/')) return { omitted: true }

    return null
  }

  const bytes = historyBytes(value)

  if (!bytes || !bytes.length) return null

  const type = declared.startsWith('image/') ? declared : sniffedImageType(bytes)

  if (!type || !type.startsWith('image/')) return null

  return { src: `data:${type};base64,${bytesToBase64(bytes)}` }
}

module.exports = { historyImagePreview }
